// extracted by mini-css-extract-plugin
module.exports = {"meal":"meal-1Po0s","name":"name-2_dmv","count":"count-1UMnd","price":"price-1O91t"};